import { useEffect } from "react";

const SITE = "https://www.axallogistics.com";

const setMeta = (attr, key, value) => {
  const el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (el) el.setAttribute("content", value);
};

export const Seo = ({ title, description, path }) => {
  useEffect(() => {
    document.title = title;
    setMeta("name", "description", description);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", `${SITE}${path}`);
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
    const canonical = document.head.querySelector('link[rel="canonical"]');
    if (canonical) canonical.setAttribute("href", `${SITE}${path}`);
  }, [title, description, path]);
  return null;
};
